module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/how_to_enjoy_photography_seasons-pick-0a7b8243e554ed79c856e01b96100301.jpg";